import { LANGUAGE_DETECTED } from '../actions/action_types';

// set default locale to en, message to en_us
export default (
  state = { locale: 'en', fullLocale: 'en', messageFileName: 'en_us' },
  action
) => {
  switch (action.type) {
    case LANGUAGE_DETECTED:
      return {
        ...state,
        locale: action.payload.locale,
        fullLocale: action.payload.fullLocale,
        messageFileName: action.payload.messageFileName
      };
    default:
      return state;
  }
};
